<button mat-button class="list-action-button" type="button" (click)="buttonClicked.emit()">{{ buttonLabel() }}</button>
